import { useTheme } from '@material-ui/core/styles';

export const useIsRTL = () => {
  const theme = useTheme();

  return theme.direction === 'rtl';
};
